import * as Colors from 'material-ui/styles/colors';

export default {
  layer: {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },
  addPanel: {
    background: Colors.green600,
    border: '1px dashed #000',
    opacity: 0.15
  }
};
